<template>
  <li class="nav-item hidden-mobile">
    <h1>{{ title }}</h1>
    <p class="hidden-sm-down">{{ subtitle }}</p>
  </li>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'li-title',
    computed: mapState({
      title: state => state.app.ui.title,
      subtitle: state => state.app.ui.subtitle
    })
  }
</script>

<style scoped>
  h1 {
    color: white;
    font-size: 1.6em;
    margin: 12px 0 2px;
  }

  p {
    color: #ccc;
    font-size: 0.9em;
    margin: 0px;
  }
</style>



// WEBPACK FOOTER //
// LiTitle.vue?21012793